import { render, staticRenderFns } from "./IncomingOffersLegend.vue?vue&type=template&id=56d21d6b&"
import script from "./IncomingOffersLegend.vue?vue&type=script&lang=js&"
export * from "./IncomingOffersLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports